'use client';

import React from 'react';

export const usePrevious = <T extends unknown>(value: T): T | undefined => {
  const ref = React.useRef<T>(undefined);
  React.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
